import CriticalRolesView from "./critical-roles-view.jsx";

export default CriticalRolesView